<template>
    <div class="absolute top-0 left-0 w-full h-full rounded-lg flex flex-col gap-4 overflow-hidden">
        
        <div class="flex min-h-0 flex-1 pt-16 lg:pt-0">
            <div class="w-72 bg-[#FAFCFD] rounded-md px-3">
                <SettingNavbar />
            </div>

            <div class="min-h-0 flex-1 border relative">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import SettingNavbar from './components/SettingNavbar.vue';

    export default {
        name:'SettingLayout',
        data(){
            return {
                
            }
        },
        components:{
            SettingNavbar
        }
    }
</script>

<style lang="scss" scoped>

</style>